export function isHiddenFromCustomerProduct(product) {
  if (!product || typeof product !== "object") return false;
  if (product.hideFromCustomer === true) return true;
  const name = String(product.name || "").trim().toLowerCase();
  return name.includes("citywide reward") || name.includes("citywise reward");
}
